import React from "react";
import ProgressBar from "react-customizable-progressbar";

import { generateRandomScore } from "../../services/dashboard";
import { getIndicatorColor, getGaugeNormalizedScore } from "../../services/gauge";

import InfoTooltip from "../../commons/InfoTooltip";

import UpdateButton from "./UpdateButton";

const GaugeGraph = ({ title, score, icon, about, indicator, message, updateLink, ofuscate, ofuscateTitle }) => {

  const finalScore = ofuscate ? generateRandomScore() : score;
  const normalizedScore = getGaugeNormalizedScore(finalScore);

  const getClassName = (className) => {
    return (className === "title" && ofuscateTitle) || ofuscate
      ? `${className} blur` : className;
  }

  const renderScoreProgressBar = () => {
    const color = getIndicatorColor(indicator);
    return (
      <ProgressBar
        radius={75}
        progress={ofuscate ? 0 : normalizedScore}
        cut={180}
        rotate={180}
        strokeWidth={7}
        strokeColor={color}
        transition=".3s ease"
        trackStrokeWidth={7}
        trackTransition=".0s"
        pointerRadius={6} 
        pointerStrokeWidth={3}
        pointerFillColor={ofuscate ? "rgba(0, 0, 0, 0)" : "#ffffff"}
        pointerStrokeColor={ofuscate ? "rgba(0, 0, 0, 0)" : color}
        initialAnimation
        initialAnimationDelay={10}
        className="gauge-graph-score-progress-bar"
      />
    );
  };

  const renderGraphDetails = () => (
    <div className={`details ${ofuscate ? "ofuscate" : null}`}>
      <img src={icon} className="icon" />
      <div className={getClassName("title")} title={title}>{title}</div>
      <div className={getClassName("final-score")}>
        <div className="score">{normalizedScore}</div>
        <div className="score-percent">%</div>
      </div>
      {message ? (
        <div className={getClassName("message")} title={message}>{message}</div>
      ) : null}
      {!ofuscate && updateLink ? (
        <div className="update-link">
          <UpdateButton href={updateLink} />
        </div>
      ) : null}
    </div>
  );

  return (
    <div className="gauge-graph">
      {about ? <InfoTooltip info={about} /> : null}
      {renderScoreProgressBar()}
      {renderGraphDetails()}
    </div>
  );
}

export default GaugeGraph;
